import { useRef } from 'react';
import {
  Button,
  Card,
  Field,
  Flex,
  Grid,
  GridItem,
  Input,
  Text,
} from '@chakra-ui/react';
import { useSearchParams } from 'react-router';

type Props = {
  onClose: () => void;
};

const Filters = ({ onClose }: Props) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const formRef = useRef<HTMLFormElement>(null);

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.ctrlKey && e.key === 'Enter') {
      e.preventDefault();
      formRef.current?.requestSubmit();
    }
  };

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    const formData = new FormData(event.currentTarget);
    const data = Object.fromEntries(formData.entries());

    const params: Record<string, string> = {};
    if (data.name) params.name = data.name as string;
    if (data.email) params.email = data.email as string;

    const newParams = new URLSearchParams(params);
    newParams.set('page', '1');
    newParams.set('limit', searchParams.get('limit') || '10');

    setSearchParams(newParams);
    onClose();
  };

  return (
    <Card.Root
      size="sm"
      variant="subtle"
      bg="grayscale.fg"
      my={4}
      p={4}
      display="flex"
      justifyContent="center"
      cursor="pointer"
    >
      <Text fontWeight={500} mb={3}>
        Filtros
      </Text>
      <form ref={formRef} onSubmit={onSubmit}>
        <Grid templateColumns="repeat(6, 1fr)" gap="2">
          <GridItem colSpan={{ base: 6, md: 3, lg: 2 }}>
            <Field.Root>
              <Field.Label>Nome</Field.Label>
              <Input
                name="name"
                placeholder="Pesquisar por nome"
                variant="subtle"
                defaultValue={searchParams.get('name') || ''}
                onKeyDown={handleKeyDown}
              />
            </Field.Root>
          </GridItem>
          <GridItem colSpan={{ base: 6, md: 3, lg: 2 }}>
            <Field.Root>
              <Field.Label>E-mail</Field.Label>
              <Input
                name="email"
                placeholder="Pesquisar pelo e-mail"
                variant="subtle"
                defaultValue={searchParams.get('email') || ''}
                onKeyDown={handleKeyDown}
              />
            </Field.Root>
          </GridItem>
        </Grid>
        <Flex justifyContent="flex-end" mt={4} gap={1}>
          <Button size="sm" variant="ghost" onClick={onClose}>
            Fechar
          </Button>
          <Button size="sm" type="submit">
            Aplicar
          </Button>
        </Flex>
      </form>
    </Card.Root>
  );
};

export default Filters;
